import RelationshipMetadata from "../../RelationshipMetadata";

class EnterpriseTermRevisionTermClassificationRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "EnterpriseTermRevisionTermClassification";
        this.parentEnterpriseComponent = "EnterpriseTermRevision";
        this.childEnterpriseComponent = "TermClassification";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "TermUSID";
    }
}

export default EnterpriseTermRevisionTermClassificationRelationshipMetadata;
